module.exports = __webpack_public_path__ + "static/img/brees-2007-slide-4.7391e94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-slide-4.jpg
// module id = zyvn
// module chunks = 1